var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");
var Selection3dController = require("./../selection3d/selection3dController");
var Plane3dMovementStateMachine = require("./plane3dMovementStateMachine.js");

var Plane3dMovementController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);
};
lib_core.inherit(Plane3dMovementController, lib_core.Controller);
Plane3dMovementController.inject = {
    selection3dController : Selection3dController
};
module.exports = Plane3dMovementController;

Plane3dMovementController.prototype.createStateMachine = function () {
    return new Plane3dMovementStateMachine(this.root, this.selection3dController.getModel());
};


